import { Case } from '@/models/case.model';
import { MatrixOrder } from '@/models/matrix-order.model';
import { useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

export const useAddEditCaseStore = defineStore('add-edit-case', () => {
  const editingProductModels = useLocalStorage<string[]>('addEditCase/editingProductModels', []);
  const editingMatrixOrders = useLocalStorage<Array<MatrixOrder>>('addEditCase/editingMatrixOrders', []);
  const editingCases = useLocalStorage<Array<Case>>('addEditCase/case', []);

  function addEditingProductModels(newSelectedProductModels: string[]) {
    editingProductModels.value = newSelectedProductModels;
  }

  function removeEditingProductModels() {
    editingProductModels.value = [];
  }

  function addEditingMatrixOrders(newEditingMatrixOrders: MatrixOrder[]) {
    editingMatrixOrders.value = newEditingMatrixOrders;
  }

  function removeEditingMatrixOrders() {
    editingMatrixOrders.value = [];
  }

  function addEditingCases(newEditingCases: Case[]) {
    editingCases.value = newEditingCases;
  }

  function removeEditingCases() {
    editingCases.value = [];
  }

  function $reset() {
    removeEditingProductModels();
    removeEditingMatrixOrders();
    removeEditingCases();
  }
  return {
    editingProductModels,
    editingMatrixOrders,
    editingCases,
    addEditingProductModels,
    removeEditingProductModels,
    addEditingMatrixOrders,
    removeEditingMatrixOrders,
    addEditingCases,
    removeEditingCases,
    $reset,
  };
});
